var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"primary--text float-right",attrs:{"light":"","large":"","to":{ name: _vm.pathTo }}},[_c('v-icon',[_vm._v(_vm._s(_vm.icone))]),_vm._v(_vm._s(_vm.descricao)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }